import { OnInit,  Component, ViewChild} from '@angular/core';
import { MdbMultiItemCarouselComponent } from 'mdb-angular-multi-item-carousel';

@Component({
  selector: 'app-objetivos-sgi',
  templateUrl: './objetivos-sgi.component.html',
  styleUrls: ['./objetivos-sgi.component.css', './objetivos-sgi.component.scss']
})
export class ObjetivosSgiComponent {
  @ViewChild('carousel') carousel!: MdbMultiItemCarouselComponent;
  slides = [
    {
      src: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/1.webp',
      img: 'assets/images/sliders-objetivos-sgi/slider1.png',
      alt: 'Table Full of Spices',
    },
    {
      src: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/2.webp',
      img: 'https://mdbootstrap.com/img/Photos/Slides/2.webp',
      alt: 'Winter Landscape',
    },
    {
      src: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/3.webp',
      img: 'https://mdbootstrap.com/img/Photos/Slides/3.webp',
      alt: 'View of the City in the Mountains',
    },
    {
      src: 'https://mdbcdn.b-cdn.net/img/Photos/Thumbnails/Slides/4.webp',
      img: 'https://mdbootstrap.com/img/Photos/Slides/4.webp',
      alt: 'Place Royale Bruxelles',
    },
  ];
}
